export interface Movie {
  id: number;
  title: string;
  category: string;
  categoryName: string;
  year: number;
  rating: number;
  description: string;
  image: string;
  duration: string;
  director: string;
  actors: string[];
  plot: string;
  isNew: boolean;
  isHot: boolean;
  updateDate: string;
}

export const categories: { slug: string; name: string; icon: string }[] = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-sword-line' },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'donghua', name: '动画片', icon: 'ri-movie-line' },
  { slug: 'zhanzheng', name: '战争片', icon: 'ri-shield-flash-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-line' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '星际征途：暗域觉醒',
    category: 'kehuan',
    categoryName: '科幻片',
    year: 2026,
    rating: 9.2,
    description: '人类在遥远星系发现神秘信号，一支精英探险队踏上了跨越光年的未知征途，却意外唤醒了沉睡亿万年的远古文明。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20astronaut%20floating%20in%20deep%20space%2C%20massive%20alien%20spaceship%20in%20background%2C%20neon%20blue%20and%20orange%20cosmic%20nebula%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20movie%20poster%20style%2C%20dark%20background%20with%20stars&width=800&height=1120&seq=movie-01&orientation=portrait',
    duration: '148分钟',
    director: '张远航',
    actors: ['刘星辰', '王浩然', '李沐阳', '陈思远'],
    plot: '公元2147年，人类在距离地球50光年的星系中探测到神秘信号。国际航天局组建了一支由精英科学家和宇航员组成的探险队，乘坐最先进的超光速飞船"启明星号"前往探索。当飞船抵达目的地时，队员们发现了一个巨大的环形人造结构，内部封印着远古文明的遗迹。随着探索的深入，沉睡的远古力量逐渐苏醒，探险队必须在时间耗尽前解开谜团，否则整个银河系将面临灭顶之灾。',
    isNew: true,
    isHot: true,
    updateDate: '2026-07-28',
  },
  {
    id: 2,
    title: '烈火战将',
    category: 'dongzuo',
    categoryName: '动作片',
    year: 2026,
    rating: 8.8,
    description: '前特种兵被迫卷入国际犯罪组织的阴谋，在极限追逃中凭借超凡战斗技巧孤身扭转战局。',
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20with%20muscular%20fighter%20in%20tactical%20gear%2C%20explosion%20and%20fire%20in%20background%2C%20intense%20expression%2C%20dramatic%20orange%20and%20red%20lighting%2C%20cinematic%20composition%2C%20movie%20poster%20style%2C%20dark%20atmosphere&width=800&height=1120&seq=movie-02&orientation=portrait',
    duration: '132分钟',
    director: '赵铁军',
    actors: ['吴天宇', '郑子豪', '刘邦伟', '孙志强'],
    plot: '退役特种兵林锋在海外执行安保任务时，意外发现了一个跨国军火走私网络。当他的战友被残忍杀害后，林锋决定不再袖手旁观。他独自潜入犯罪组织的核心据点，在一场场惊心动魄的追逐与搏杀中，凭借过人的战术素养和战斗技巧，一步步瓦解了这个庞大的犯罪帝国。然而，最终的敌人却来自他最意想不到的地方。',
    isNew: false,
    isHot: true,
    updateDate: '2026-07-25',
  },
  {
    id: 3,
    title: '欢乐一家亲',
    category: 'xiju',
    categoryName: '喜剧片',
    year: 2026,
    rating: 8.5,
    description: '三代同堂的家庭在春节期间闹出连环笑话，温馨爆笑的合家欢故事让人捧腹不已。',
    image: 'https://readdy.ai/api/search-image?query=Funny%20Chinese%20comedy%20movie%20poster%20with%20happy%20family%20gathering%2C%20bright%20warm%20colors%2C%20festive%20atmosphere%2C%20laughter%20and%20joy%2C%20clean%20simple%20background%2C%20cinematic%20lighting%2C%20movie%20poster%20style&width=800&height=1120&seq=movie-03&orientation=portrait',
    duration: '118分钟',
    director: '黄大明',
    actors: ['沈腾飞', '马丽娜', '张一山', '杨紫曦'],
    plot: '老李家的三个子女带着各自的家庭回老家过年。大儿子是事业有成的企业家，二女儿是追求自由的艺术家，小儿子则是个整天做白日梦的创业青年。三代人聚在一起，从年夜饭的菜单到相亲的安排，从装修风格到育儿理念，每一件事都能引发一连串令人捧腹的闹剧。在欢笑与泪水中，一家人重新找回了亲情的力量。',
    isNew: true,
    isHot: false,
    updateDate: '2026-07-30',
  },
  {
    id: 4,
    title: '深海迷踪',
    category: 'kehuan',
    categoryName: '科幻片',
    year: 2026,
    rating: 8.9,
    description: '深海科考队在马里亚纳海沟底部发现了一个与世隔绝的未知生态系统，危险与奇观并存。',
    image: 'https://readdy.ai/api/search-image?query=Underwater%20sci-fi%20thriller%20movie%20poster%2C%20deep%20ocean%20with%20bioluminescent%20creatures%2C%20submarine%20in%20dark%20water%2C%20mysterious%20glowing%20light%2C%20cinematic%20atmosphere%2C%20dark%20blue%20and%20teal%20tones%2C%20movie%20poster%20style&width=800&height=1120&seq=movie-04&orientation=portrait',
    duration: '142分钟',
    director: '陈海波',
    actors: ['周迅捷', '赵文卓', '刘诗涵', '王凯旋'],
    plot: '一支国际联合科考队乘坐最先进的深海探测器潜入马里亚纳海沟，在11000米的深渊中发现了一个完全不依赖阳光的生态系统。这里有发光的巨型生物、奇异的矿物质结构，以及一个似乎具有智能特征的神秘存在。当探测器出现故障，队员们被困在海底时，他们必须在这个未知世界中求生，并揭示深海之下隐藏的惊天秘密。',
    isNew: true,
    isHot: true,
    updateDate: '2026-07-31',
  },
  {
    id: 5,
    title: '恋恋初夏',
    category: 'aiqing',
    categoryName: '爱情片',
    year: 2026,
    rating: 8.3,
    description: '两个年轻人在海边小镇相遇，一场夏日的浪漫邂逅改变了他们各自的人生轨迹。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20with%20young%20couple%20walking%20on%20beach%20at%20sunset%2C%20warm%20golden%20light%2C%20soft%20dreamy%20atmosphere%2C%20ocean%20waves%2C%20summer%20vibe%2C%20cinematic%20composition%2C%20movie%20poster%20style%2C%20clean%20background&width=800&height=1120&seq=movie-05&orientation=portrait',
    duration: '108分钟',
    director: '林小婉',
    actors: ['杨洋', '赵露丝', '王一博', '宋雨绮'],
    plot: '城市白领程朗因工作压力太大，独自来到海边小镇度假。在那里，他遇到了经营民宿的女孩苏夏。一个月的相处中，两人从陌生到熟悉，从争执到理解，在阳光、海风和星空下，一段纯粹美好的感情悄然生长。但当假期结束，现实与理想之间的抉择摆在了两人面前。',
    isNew: false,
    isHot: false,
    updateDate: '2026-07-20',
  },
  {
    id: 6,
    title: '暗夜惊魂',
    category: 'kongbu',
    categoryName: '恐怖片',
    year: 2026,
    rating: 8.1,
    description: '六个年轻人闯入废弃多年的精神病院探险，却遭遇了远超想象的恐怖事件。',
    image: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%20with%20dark%20abandoned%20building%2C%20eerie%20moonlight%2C%20shadowy%20figure%2C%20foggy%20atmosphere%2C%20cold%20blue%20and%20black%20tones%2C%20scary%20cinematic%20composition%2C%20movie%20poster%20style&width=800&height=1120&seq=movie-06&orientation=portrait',
    duration: '105分钟',
    director: '方志强',
    actors: ['张子枫', '彭昱畅', '朱一龙', '文咏珊'],
    plot: '六名大学生为了完成一篇关于都市传说的研究报告，决定在午夜时分进入一栋废弃了三十年的精神病院。起初一切只是普通的探险，但随着他们深入建筑内部，诡异的现象接连发生：走廊里传来脚步声、镜子里出现不该存在的倒影、房间的布局似乎在不断变化。当他们想要离开时，发现所有的出口都消失了。在这座充满怨念的建筑中，每个人内心最深处的恐惧都将被唤醒。',
    isNew: true,
    isHot: false,
    updateDate: '2026-07-29',
  },
  {
    id: 7,
    title: '龙之传说：觉醒',
    category: 'donghua',
    categoryName: '动画片',
    year: 2026,
    rating: 9.0,
    description: '少年龙族后裔踏上寻找失落龙珠的冒险之旅，精美画面与动人故事征服全年龄段观众。',
    image: 'https://readdy.ai/api/search-image?query=Animated%20fantasy%20movie%20poster%20with%20young%20boy%20and%20magical%20dragon%2C%20vibrant%20colors%2C%20floating%20islands%2C%20Chinese%20mythology%20style%2C%20beautiful%20scenery%2C%20cinematic%20lighting%2C%20movie%20poster%20style%2C%20clean%20composition&width=800&height=1120&seq=movie-07&orientation=portrait',
    duration: '125分钟',
    director: '田晓鹏',
    actors: ['杨恩又', '黄渤', '周深', '刘昊然'],
    plot: '在一个人与龙和谐共存的世界里，少年小风偶然发现自己身上流淌着远古龙族的血脉。当黑暗势力试图夺取散落在世界各地的七颗龙珠时，小风与他的伙伴——一只会说人话的小火龙阿焰，踏上了冒险之旅。他们穿越云端之城、深海龙宫、火焰山脉，在寻找龙珠的过程中，小风逐渐觉醒体内的龙之力，也明白了真正的力量来自于勇气、友谊和守护的决心。',
    isNew: false,
    isHot: true,
    updateDate: '2026-07-22',
  },
  {
    id: 8,
    title: '铁血防线',
    category: 'zhanzheng',
    categoryName: '战争片',
    year: 2026,
    rating: 8.7,
    description: '基于真实历史改编，一支小分队在敌后浴血奋战，用生命守护战略要地的壮烈故事。',
    image: 'https://readdy.ai/api/search-image?query=War%20movie%20poster%20with%20soldiers%20in%20battle%2C%20explosions%20and%20smoke%2C%20heroic%20stance%2C%20dramatic%20orange%20and%20grey%20lighting%2C%20dusty%20battlefield%2C%20cinematic%20composition%2C%20movie%20poster%20style%2C%20dark%20atmosphere&width=800&height=1120&seq=movie-08&orientation=portrait',
    duration: '155分钟',
    director: '陆川',
    actors: ['吴京', '张译', '段奕宏', '李晨'],
    plot: '1944年深秋，一支由12人组成的精锐小分队接到命令，必须在增援部队到达前守住一座关键桥梁72小时。面对数倍于己的敌军，小分队成员利用地形优势，与敌人展开了一场惊心动魄的阵地战。弹药耗尽后，他们用刺刀、石块甚至赤手空拳继续战斗。72小时后，当增援部队抵达时，只剩3人幸存。这座桥成为了扭转战局的关键，也见证了普通战士的伟大牺牲。',
    isNew: false,
    isHot: true,
    updateDate: '2026-07-18',
  },
  {
    id: 9,
    title: '猎影行动',
    category: 'dongzuo',
    categoryName: '动作片',
    year: 2026,
    rating: 8.6,
    description: '顶尖女特工独自追踪国际恐怖组织，在异国街头展开高能动作追逐，拳拳到肉。',
    image: 'https://readdy.ai/api/search-image?query=Female%20action%20hero%20movie%20poster%2C%20agent%20in%20black%20tactical%20outfit%2C%20urban%20night%20setting%2C%20neon%20lights%2C%20intense%20gaze%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20movie%20poster%20style%2C%20dark%20background&width=800&height=1120&seq=movie-09&orientation=portrait',
    duration: '128分钟',
    director: '李仁港',
    actors: ['章子怡', '甄子丹', '谢霆锋', '余文乐'],
    plot: '国安局王牌特工苏晚接到紧急任务：一个国际恐怖组织计划在一周内对多个城市发动同步袭击。情报显示该组织的头目隐藏在东南亚某城市。苏晚独自前往目标城市，在当地的街头巷尾与恐怖分子展开了一场又一场惊险的追逐战。她必须在72小时内找到恐怖组织的老巢，同时还要应对来自内部的背叛。在这场猎人与猎物的博弈中，胜负只在一线之间。',
    isNew: true,
    isHot: false,
    updateDate: '2026-07-27',
  },
  {
    id: 10,
    title: '美食大冒险',
    category: 'xiju',
    categoryName: '喜剧片',
    year: 2026,
    rating: 8.4,
    description: '落魄厨师意外获得神秘食谱，踏上全国美食之旅，一路笑料百出温暖人心。',
    image: 'https://readdy.ai/api/search-image?query=Food%20comedy%20movie%20poster%20with%20chef%20holding%20delicious%20dishes%2C%20colorful%20Chinese%20cuisine%2C%20happy%20expression%2C%20warm%20kitchen%20lighting%2C%20bright%20and%20appetizing%20atmosphere%2C%20cinematic%20composition%2C%20movie%20poster%20style&width=800&height=1120&seq=movie-10&orientation=portrait',
    duration: '115分钟',
    director: '徐峥',
    actors: ['黄渤', '王宝强', '刘浩然', '沈月'],
    plot: '曾是五星级酒店主厨的阿强因一次意外失去了工作和声誉，沦落到在街边卖炒饭。一天，他从一位即将离世的老厨师手中得到了一本神秘食谱，据说里面记载了失传已久的中华料理秘方。为了验证这些秘方，阿强踏上了环游全国的美食之旅。从四川的麻辣火锅到广东的精致点心，从云南的野生菌到东北的铁锅炖，他在寻找美食真谛的路上，也重新找到了人生的方向。',
    isNew: false,
    isHot: false,
    updateDate: '2026-07-15',
  },
  {
    id: 11,
    title: '大地之歌',
    category: 'jilupian',
    categoryName: '纪录片',
    year: 2026,
    rating: 9.3,
    description: '横跨中国七大地理区域的史诗级自然纪录片，用4K镜头捕捉华夏大地的壮美风光。',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20stunning%20Chinese%20landscape%2C%20mountains%20and%20rivers%2C%20golden%20sunlight%2C%20misty%20valleys%2C%20dramatic%20natural%20scenery%2C%20cinematic%20composition%2C%20poster%20style%2C%20clean%20beautiful%20background&width=800&height=1120&seq=movie-11&orientation=portrait',
    duration: '168分钟',
    director: '陆川 / 李成才',
    actors: ['旁白：陈道明'],
    plot: '《大地之歌》历时五年拍摄，跨越中国七大地理区域，从青藏高原的雪山冰川到南海的碧波珊瑚，从东北的原始森林到西北的戈壁荒漠。影片以惊人的4K画质记录了雪豹在悬崖上狩猎、丹顶鹤在湿地起舞、金丝猴在丛林中嬉戏、藏羚羊在高原上迁徙等珍贵画面。这不仅是一部自然纪录片，更是一封献给华夏大地的情书，呼吁人们珍惜和保护这片土地上的每一个生命。',
    isNew: false,
    isHot: true,
    updateDate: '2026-07-10',
  },
  {
    id: 12,
    title: '平行恋人',
    category: 'aiqing',
    categoryName: '爱情片',
    year: 2026,
    rating: 8.2,
    description: '在时间循环中反复相遇的两个人，每一次重新开始都让爱更深一分。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20movie%20poster%20with%20couple%20reaching%20toward%20each%20other%2C%20time%20portal%20effect%2C%20soft%20purple%20and%20pink%20lighting%2C%20dreamy%20atmosphere%2C%20floating%20clock%20elements%2C%20cinematic%20composition%2C%20movie%20poster%20style&width=800&height=1120&seq=movie-12&orientation=portrait',
    duration: '112分钟',
    director: '曾国祥',
    actors: ['易烊千玺', '周冬雨', '彭昱畅', '张子枫'],
    plot: '大学生林夕某天发现自己被困在了同一天的时间循环中。更奇怪的是，在这个循环中，他每天都会在不同场合遇到同一个女孩——苏念。而每一次相遇，苏念对他的态度都完全不同，有时候是陌生人，有时候是朋友，有时候甚至是恋人。林夕逐渐意识到，他穿越到了不同的平行时空，而在每一个时空中，他都不可救药地爱上了同一个女孩。他必须在无数次循环中找到方法，打破时空壁垒，找到那个真正属于他的苏念。',
    isNew: true,
    isHot: false,
    updateDate: '2026-07-26',
  },
];

export const heroMovies: Movie[] = movies.filter(m => m.isHot).slice(0, 5);

export const newMovies: Movie[] = movies.filter(m => m.isNew);

export const hotMovies: Movie[] = movies.filter(m => m.isHot);

export function getMoviesByCategory(slug: string): Movie[] {
  return movies.filter(m => m.category === slug);
}

export function getMovieById(id: number): Movie | undefined {
  return movies.find(m => m.id === id);
}

export function getCategoryName(slug: string): string {
  const cat = categories.find(c => c.slug === slug);
  return cat ? cat.name : slug;
}